var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var _digest, _digestAlg;
var BceFile = /** @class */ (function () {
    function BceFile(id, name, data) {
        _digest.set(this, void 0);
        _digestAlg.set(this, void 0);
        this.id = id;
        this.name = name;
        this.type = data.type;
        this.blob = data;
    }
    BceFile.prototype.hash = function (algorithm, output) {
        if (algorithm === void 0) { algorithm = 'SHA-256'; }
        if (output === void 0) { output = 'hex'; }
        return __awaiter(this, void 0, void 0, function () {
            var data, buffer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!__classPrivateFieldGet(this, _digest) || __classPrivateFieldGet(this, _digestAlg) !== algorithm)) return [3 /*break*/, 3];
                        return [4 /*yield*/, new Response(this.blob).arrayBuffer()];
                    case 1:
                        data = _a.sent();
                        return [4 /*yield*/, crypto.subtle.digest(algorithm, data)];
                    case 2:
                        buffer = _a.sent();
                        __classPrivateFieldSet(this, _digestAlg, algorithm);
                        __classPrivateFieldSet(this, _digest, Array.from(new Uint8Array(buffer)));
                        _a.label = 3;
                    case 3:
                        switch (output) {
                            default:
                            case 'array':
                                return [2 /*return*/, __classPrivateFieldGet(this, _digest)];
                            case 'hex':
                                return [2 /*return*/, __classPrivateFieldGet(this, _digest).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('')];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return BceFile;
}());
_digest = new WeakMap(), _digestAlg = new WeakMap();
var modulo = function (i1, i2) {
    return ((i1 % i2) + i2) % i2;
};
var ripple = function (el, event) {
    // Create ripple element at mouse position
    var ripple = document.createElement('bce-ripple');
    var rect = el.getBoundingClientRect();
    ripple.x = event.clientX - rect.left;
    ripple.y = event.clientY - rect.top;
    // Append ripple to el & remove after 500ms
    el.appendChild(ripple);
    setTimeout(function () { return ripple.parentElement.removeChild(ripple); }, 500);
};
function throttle(f, wait, options) {
    if (wait === void 0) { wait = 200; }
    if (options === void 0) { options = {}; }
    var opts = Object.assign({ ensureLast: false }, options);
    var throttled = false;
    var context = null;
    var args = [];
    return function () {
        context = this;
        args = arguments;
        if (throttled)
            return;
        f.apply(context, args);
        throttled = true;
        setTimeout(function () {
            throttled = false;
            if (opts.ensureLast)
                f.apply(context, args);
        }, wait);
    };
}
export { BceFile as B, modulo as m, ripple as r, throttle as t };
